<template>
  <section :id="$options.name" class="info" v-if="details.description.important_information">
    <h2 class=" info__title">Da sapere</h2>
    <div class="info__text">
      <span v-html="details.description.important_information.it.replaceAll('.', '.<br>')" />
      <div class="info__license" v-if="details.description.license_numbers.length">
        <span class="info__license-title">Numero di licenza: </span>
        <span class="info__license-number" v-for="(license, license_index) in details.description.license_numbers" :key="_uid+license_index">
          {{ license }}
        </span>
      </div>
    </div>
    <key-info class="info__key" :hotel="details"/>
  </section>
</template>

<script>
import KeyInfo from '@bookingv3/components/blocks/key-info'

export default {
  inheritAttrs: false,
  name: 'info',

  components: {
    'key-info': KeyInfo,
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .info {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__text {
      background-color: #fafcff;
      border-radius: 10px;
      margin-bottom: 0;
      padding: 20px;

      @include media-breakpoint-up(xl){
        line-height: $font-size-base * 2;
      }
    }

    &__license {
      display: flex;
      align-items: center;
      font-size: $font-size-md;
      margin-top: 5px;

      &-title {
        font-weight: $vb-font-weight-semibold;
        margin-right: 5px;
      }

      &-number {
        margin-right: 8px;
      }
    }

    &__key {
      @extend .info__text;
      margin-top: $grid-gutter-width;
    }
  }

</style>